// @ts-nocheck
import React from 'react';
import { useParams } from 'react-router-dom';
import TeamCheckInPanel from '@/components/checkin/TeamCheckInPanel';

/** Staff route /staff/checkin/:eventId — same team check-in UI as the admin page. */
const StaffEventCheckInPage: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  return <TeamCheckInPanel eventId={eventId} />;
};

export default StaffEventCheckInPage;
